export const PERMISIION = {
  CANCEL_CERTIFICATES: 'Cancelar Certificados',
  SKIP_CERTIFICATE_CONFIG: 'Omite Configuracion de Certificados',
}